import { render, staticRenderFns } from "./fragment-text-field.vue?vue&type=template&id=16849920&scoped=true&"
import script from "./fragment-text-field.vue?vue&type=script&lang=js&"
export * from "./fragment-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16849920",
  null
  
)

export default component.exports